import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const mailerSections = [
  { label: "Waiting", name: "waiting", color: "var(--mantine-color-gray-1)" },
  { label: "Sent", name: "sent", color: "var(--mantine-color-gray-4)" },
  {
    label: "Delivered",
    name: "delivered",
    color: "var(--mantine-color-blue-4)",
  },
  { label: "Opened", name: "opened", color: "var(--mantine-color-green-4)" },
  { label: "Bounced", name: "bounced", color: "var(--mantine-color-orange-3)" },
  { label: "Errored", name: "errored", color: "var(--mantine-color-red-4)" },
];

// waiting, queued, sent, delivered, errored
const smsSections = [
  { label: "Waiting", name: "waiting", color: "var(--mantine-color-gray-1)" },
  { label: "Queued", name: "queued", color: "var(--mantine-color-gray-2)" },
  { label: "Sent", name: "sent", color: "var(--mantine-color-gray-4)" },
  {
    label: "Delivered",
    name: "delivered",
    color: "var(--mantine-color-blue-4)",
  },
  { label: "Errored", name: "errored", color: "var(--mantine-color-red-4)" },
];

export default function BulkCommunicationMailerStatus({ statusInfo, variety }) {
  if (!statusInfo || statusInfo.disposition_formatted === "waiting")
    return null;

  const sections = variety === 2 ? smsSections : mailerSections;

  return (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={{
          chart: {
            height: "350px",
            type: "pie",
            style: {
              fontFamily: "inherit",
            },
          },
          title: {
            text: statusInfo?.disposition_formatted || "",
            // text: "",
          },
          tooltip: {
            valueSuffix: "",
          },
          subtitle: {
            // text: "",
            text: "current status",
          },
          plotOptions: {
            series: {
              allowPointSelect: true,
              cursor: "pointer",
              dataLabels: [
                {
                  enabled: true,
                  distance: 20,
                },
                {
                  enabled: true,
                  distance: -40,
                  format: "{point.percentage:.1f}%",
                  style: {
                    fontSize: "1.2em",
                    textOutline: "none",
                    opacity: 0.7,
                  },
                  filter: {
                    operator: ">",
                    property: "percentage",
                    value: 10,
                  },
                },
              ],
            },
          },
          series: [
            {
              name: "Amount",
              colorByPoint: true,
              data: sections
                .filter((f) => statusInfo[f.name] > 0)
                .map((field) => ({
                  name: field.label,
                  y: statusInfo[field.name],
                  color: field.color,
                })),
            },
          ],
          credits: {
            enabled: false,
          },
        }}
      />
    </div>
  );
}
